import { IDR } from '@/libs/currency'

// eslint-disable-next-line import/prefer-default-export
export const performaMitraFields = [
  {
    key: 'no',
    label: 'No',
    thStyle: {
      textTransform: 'capitalize',
      color: 'black',
    },
    tdClass: 'text-black',
  },
  {
    key: 'warehouse_name',
    label: 'Mitra Gudang',
    thStyle: {
      textTransform: 'capitalize',
      color: 'black',
    },
    tdClass: 'text-black',
    class: 'p-1 align-top',
  },
  {
    key: 'location',
    label: 'Kota',
    thStyle: {
      textTransform: 'capitalize',
      color: 'black',
    },
    tdClass: 'text-black',
    class: 'p-1 align-top',
  },
  {
    key: 'total_outbounds',
    label: 'Outbond',
    thStyle: {
      textTransform: 'capitalize',
      color: 'black',
    },
    tdClass: 'text-black',
    class: 'p-1 align-top',
    sortable: true,
  },
  {
    key: 'total_mitra_earnings',
    label: 'Omset',
    thStyle: {
      textTransform: 'capitalize',
      color: 'black',
    },
    tdClass: 'text-black',
    class: 'p-1 align-top',
    sortable: true,
    formatter: value => IDR(value).replace('.', ''),
  },
  {
    key: 'total_kompack_revenue',
    label: 'Revenue Kompack',
    thStyle: {
      textTransform: 'capitalize',
      color: 'black',
    },
    tdClass: 'text-black',
    class: 'p-1 align-top',
    formatter: value => IDR(value).replace('.', ''),
  },
]
